module.exports = __webpack_public_path__ + "img/97.8e4cca4e.png";